import "./Panel.css";
import imgLogout from "../../assets/Icon/login-logout-arrow.png";
import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import icon2 from "../../assets/Icon/02.png";
import icon2Active from "../../assets/Icon/02+.png";
import icon3 from "../../assets/Icon/03.png";
import icon3Active from "../../assets/Icon/03+.png";
import icon4 from "../../assets/Icon/04.png";
import icon4Active from "../../assets/Icon/04+.png";
import icon5 from "../../assets/Icon/05.png";
import icon5Active from "../../assets/Icon/05+.png";
import icon7 from "../../assets/Icon/07.png";
import icon7Active from "../../assets/Icon/07+.png";
import icon9 from "../../assets/Icon/09.png";
import icon9Active from "../../assets/Icon/09+.png";
import icon16 from "../../assets/Icon/16.png";
import icon16Active from "../../assets/Icon/16+.png";
import icon17 from "../../assets/Icon/17.png";
import icon17Active from "../../assets/Icon/17+.png";
import businessImg from "../../assets/Icon/building.png";
import businessImgctive from "../../assets/Icon/businessImgctive.png";
import { CheckIdentity } from "../../Common/ConvertIdentity";

function Panel({ element }) {
  const side = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [Min, seMin] = useState(false);

  const Exp = (date) => {
    const targetDate = new Date(date);
    const nowUtc = new Date().getTime();
    const diffMs = targetDate.getTime() - nowUtc;
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    if (totalMinutes > 0) {
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;

      return `${days} روز`;
    } else {
      return 0;
    }
  };

  const Logout = () => {
    localStorage.removeItem("Identity");
    localStorage.removeItem("Username");
    localStorage.removeItem("CompanyUserName");
    localStorage.removeItem("Token");
    navigate("/login");
  };
  return (
    <div className="d-flex justify-content-start Panel">
      <div
        className={`${
          Min ? "sideMin " : "side "
        } d-flex justify-content-start align-items-start flex-column`}
        ref={side}
      >
        <div
          onClick={() => {
            seMin(!Min);
          }}
          className={`itemSide d-flex ${
            Min ? "justify-content-center" : "justify-content-start"
          } align-items-center border border-white`}
        >
          <img width={"30px"} src={Min ? icon17Active : icon17} alt="" />
          {!Min && (
            <div className="d-flex flex-column justify-content-start me-2 pointer">
              <span className="">{localStorage.getItem("Username")}</span>
              <span> {Exp(localStorage.getItem("ExpTime"))}</span>
            </div>
          )}
        </div>

        {
          <div
            onClick={() => {
              CheckIdentity("ShowMarket") && navigate("/Panel/ShowMarket");
            }}
            className={
              location.pathname.includes("ShowMarket")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive `
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("ShowMarket") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("ShowMarket") ? icon2Active : icon2
              }
              alt=""
            />
            {!Min && <span className="me-2">نمای بازار</span>}
          </div>
        }

        {
          <div
            onClick={() => {
              CheckIdentity("CompetitorPackeageBy") &&
                navigate("/Panel/ShowBuy");
            }}
            className={
              location.pathname.includes("ShowBuy")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("CompetitorPackeageBy")
                      ? "pointer"
                      : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={location.pathname.includes("ShowBuy") ? icon2Active : icon2}
              alt=""
            />
            {!Min && <span className="me-2">نمای خرید</span>}
          </div>
        }
        {
          <div
            onClick={() => {
              CheckIdentity("StockAll") &&
                navigate("/Panel/CompanyManage/StockAll");
            }}
            className={
              location.pathname.includes("StockAll")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("StockAll") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={location.pathname.includes("StockAll") ? icon2Active : icon2}
              alt=""
            />
            {!Min && <span className="me-2">نمای انبار</span>}
          </div>
        }
        {CheckIdentity("User") && (
          <div
            onClick={() => {
              navigate("/Panel/User");
            }}
            className={
              location.pathname.includes("User")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={location.pathname.includes("User") ? icon2Active : icon2}
              alt=""
            />
            {!Min && <span className="me-2 ">کاربران</span>}
          </div>
        )}
        {CheckIdentity("Product") && (
          <div
            onClick={() => {
              navigate("/Panel/Products");
            }}
            className={
              location.pathname.includes("Products")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={location.pathname.includes("Products") ? icon3Active : icon3}
              alt=""
            />
            {!Min && <span className="me-2">محصول</span>}
          </div>
        )}
        {CheckIdentity("Competitor") && (
          <div
            onClick={() => {
              navigate("/Panel/CompetitorsCategory");
            }}
            className={
              location.pathname.includes("Competitors")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("Competitors") ? icon4Active : icon4
              }
              alt=""
            />
            {!Min && <span className="me-2">مراجع</span>}
          </div>
        )}
        {CheckIdentity("CompetitorPrice") && (
          <div
            onClick={() => {
              navigate("/Panel/CompetitorPrice");
            }}
            className={
              location.pathname.includes("CompetitorPrice")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("CompetitorPrice")
                  ? icon5Active
                  : icon5
              }
              alt=""
            />

            {!Min && <span className="me-2">قیمت گذاری مراجع</span>}
          </div>
        )}
        {CheckIdentity("Company") && (
          <div
            onClick={() => {
              navigate("/Panel/Warehouses");
            }}
            className={
              location.pathname.includes("Warehouses")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("Warehouses")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">برنامه انبار داری</span>}
          </div>
        )}
        {CheckIdentity("Company") && (
          <div
            onClick={() => {
              navigate("/Panel/Companys");
            }}
            className={
              location.pathname.includes("Companys")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("Companys")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">شرکت ها</span>}
          </div>
        )}
        {CheckIdentity("EmailSetting") && (
          <div
            onClick={() => {
              navigate("/Panel/EmailSetting");
            }}
            className={
              location.pathname.includes("EmailSetting")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("EmailSetting")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">تنظیمات ایمیل </span>}
          </div>
        )}
        {CheckIdentity("ServiceOut") && (
          <div
            onClick={() => {
              navigate("/Panel/ServiceOut");
            }}
            className={
              location.pathname.includes("ServiceOut")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("ServiceOut")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">ServiceOut</span>}
          </div>
        )}
        {CheckIdentity("Setting") && (
          <div
            onClick={() => {
              navigate("/Panel/Settings");
            }}
            className={
              location.pathname.includes("Settings")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("Settings")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">تنظیمات</span>}
          </div>
        )}
        {CheckIdentity("SmsSetting") && (
          <div
            onClick={() => {
              navigate("/Panel/SmsSetting");
            }}
            className={
              location.pathname.includes("SmsSetting")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("SmsSetting")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">تنظیمات اسمس </span>}
          </div>
        )}
        {CheckIdentity("Info") && (
          <div
            onClick={() => {
              navigate("/Panel/Info");
            }}
            className={
              location.pathname.includes("Info")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("Info")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">Info</span>}
          </div>
        )}
        {
          <div
            onClick={() => {
              CheckIdentity("CompanyProduct") &&
                navigate("/Panel/CompanyProduct");
            }}
            className={
              location.pathname.includes("CompanyProduct")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("CompanyProduct")
                      ? "pointer"
                      : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("CompanyProduct")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2">کالا های شرکت</span>}
          </div>
        }
        { (
          <div
            onClick={() => {
             CheckIdentity("Stock") && navigate("/Panel/CompanyStoreStocks");
            }}
            className={
              location.pathname.includes("CompanyStoreStocks")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("Stock")
                      ? "pointer"
                      : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("CompanyStoreStocks")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2 ">موجودی کالا</span>}
          </div>
        )}
        {
          <div
            onClick={() => {
              CheckIdentity("Stock") &&
                navigate("/Panel/CompanyStoreStockByColor");
            }}
            className={
              location.pathname.includes("CompanyStoreStockByColor")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("Stock") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("CompanyStoreStockByColor")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2 ">موجودی کالا با رنگ</span>}
          </div>
        }
        {
          <div
            onClick={() => {
              CheckIdentity("AvrageRate") &&
                navigate("/Panel/CompanyStoreAvrage");
            }}
            className={
              location.pathname.includes("CompanyStoreAvrage")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white  ${
                    CheckIdentity("AvrageRate") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("CompanyStoreAvrage")
                  ? businessImgctive
                  : businessImg
              }
              alt=""
            />

            {!Min && <span className="me-2 ">نرخ میانگین کالا</span>}
          </div>
        }
        {
          <div
            onClick={() => {
              CheckIdentity("OfferPrice") && navigate("/Panel/PriceOffer");
            }}
            className={
              location.pathname.includes("PriceOffer")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white  ${
                    CheckIdentity("OfferPrice") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("PriceOffer") ? icon7Active : icon7
              }
              alt=""
            />
            {!Min && <span className="me-2 ">پیشنهاد قیمت</span>}
          </div>
        }
        {
          <div
            onClick={() => {
              CheckIdentity("Price") && navigate("/Panel/Prices");
            }}
            className={
              location.pathname.includes("Prices")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("Price") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={location.pathname.includes("Prices") ? icon7Active : icon7}
              alt=""
            />
            {!Min && <span className="me-2 ">قیمت گذاری </span>}
          </div>
        }
        {
          <div
            onClick={() => {
              CheckIdentity("ListPrice") && navigate("/Panel/ListPrice");
            }}
            className={
              location.pathname.includes("ListPrice")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white ${
                    CheckIdentity("ListPrice") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("ListPrice") ? icon9Active : icon9
              }
              alt=""
            />
            {!Min && <span className="me-2 ">لیست قیمت</span>}
          </div>
        }
        {
          <div
            onClick={() => {
              CheckIdentity("Site") && navigate("/Panel/Site");
            }}
            className={
              location.pathname.includes("Site")
                ? `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white  ${
                    CheckIdentity("Site") ? "pointer" : "text-secondary"
                  }`
            }
          >
            <img
              width={"30px"}
              src={location.pathname.includes("Site") ? icon16Active : icon16}
              alt=""
            />
            {!Min && <span className="me-2 ">سایت</span>}
          </div>
        }
        {CheckIdentity("Supplier") && (
          <div
            onClick={() => {
              navigate("/Panel/Suppliers");
            }}
            className={
              location.pathname.includes("Suppliers")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("Suppliers") ? icon16Active : icon16
              }
              alt=""
            />
            {!Min && <span className="me-2 ">Supplier</span>}
          </div>
        )}
        {CheckIdentity("ShowSupplier") && (
          <div
            onClick={() => {
              navigate("/Panel/ShowSupplier");
            }}
            className={
              location.pathname.includes("ShowSupplier")
                ? `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white itemActive`
                : `itemSide pointer d-flex ${
                    Min ? "justify-content-center" : "justify-content-start"
                  } align-items-center border border-white`
            }
          >
            <img
              width={"30px"}
              src={
                location.pathname.includes("ShowSupplier")
                  ? icon16Active
                  : icon16
              }
              alt=""
            />
            {!Min && <span className="me-2 ">تامیین کننده</span>}
          </div>
        )}
        <div
          onClick={() => {
            navigate("/Panel/ChangePass");
          }}
          className={
            location.pathname.includes("ChangePass")
              ? `itemSide pointer d-flex ${
                  Min ? "justify-content-center" : "justify-content-start"
                } align-items-center border border-white itemActive`
              : `itemSide pointer d-flex ${
                  Min ? "justify-content-center" : "justify-content-start"
                } align-items-center border border-white`
          }
        >
          <img
            width={"30px"}
            src={
              location.pathname.includes("ChangePass") ? icon16Active : icon16
            }
            alt=""
          />
          {!Min && <span className="me-2">تغییر رمز عبور</span>}
        </div>
      </div>
      <div
        className={`d-flex align-items-start w-100 flex-column ${
          Min ? "PanelElementMin" : "PanelElement"
        }`}
      >
        <div className="d-flex justify-content-end w-100 mb-3">
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => {
              Logout();
            }}
          >
            <button className="btnLogout">
              <img src={imgLogout} alt="" />
            </button>
          </div>
        </div>
        <div className="d-flex flex-column w-100">{element}</div>
      </div>
    </div>
  );
}

export default Panel;
